import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {loginStyles} from '../Modal/Modal.config';
import ModalWrapper from '../Modal/Modal';
import {
  StyledWrapper,
  Content,
  TextWrapper,
  Title,
  ButtonsWrapper,
  OK,
  Cancel,
} from './PopupModal.style';
import {
  FieldRow,
  RatingRow,
  Label,
  Textarea,
  RatingWrapper,
  ErrorText,
  RatingErrorText,
} from './LeaveReviewModal.style';
import Rating from '../Rating/Rating';

const LeaveReviewModal = ({onSubmit, onClose, isSuccess, submitError}) => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [errors, setErrors] = useState({});

  const handleRatingChange = value => {
    setRating(value);
    setErrors(prev => ({...prev, rating: null}));
  };

  const handleCommentChange = e => {
    setComment(e.target.value);
    setErrors(prev => ({...prev, comment: null}));
  };

  const handleSubmit = () => {
    const next = {};
    if (!rating) next.rating = 'Please select a star rating';
    if (!comment.trim()) next.comment = 'Please enter a comment';
    if (Object.keys(next).length) {
      setErrors(next);
      return;
    }
    onSubmit({rating, comment});
  };

  return (
    <ModalWrapper
      customStyles={loginStyles}
      isOpen={true}
      closeModal={onClose}
      data-rw="leave-review-modal"
    >
      <StyledWrapper $isNotFullScreen={true}>
        <Content>
          <TextWrapper>
            {isSuccess || submitError ? (
              <>
                <Title>{submitError ? 'Sorry' : 'Thank You'}</Title>
                <div>{submitError || 'Thank you for leaving your review'}</div>
                <ButtonsWrapper>
                  <OK onClick={onClose} data-rw="review-modal--thankyou-ok">
                    OK
                  </OK>
                </ButtonsWrapper>
              </>
            ) : (
              <>
                <Title>LEAVE A REVIEW</Title>
                <RatingRow>
                  <Label>Rating</Label>
                  <RatingWrapper>
                    <Rating
                      rating={rating}
                      totalStars={5}
                      setRating={handleRatingChange}
                    />
                  </RatingWrapper>
                  {errors.rating && (
                    <RatingErrorText>{errors.rating}</RatingErrorText>
                  )}
                </RatingRow>
                <FieldRow>
                  <Label>Comments</Label>
                  <Textarea
                    value={comment}
                    onChange={handleCommentChange}
                    placeholder="Share your thoughts about this product..."
                  />
                  {errors.comment && <ErrorText>{errors.comment}</ErrorText>}
                </FieldRow>
                <ButtonsWrapper>
                  <OK onClick={handleSubmit} data-rw="review-modal--ok-button">
                    Submit
                  </OK>
                  <Cancel
                    onClick={onClose}
                    data-rw="review-modal--cancel-button"
                  >
                    Cancel
                  </Cancel>
                </ButtonsWrapper>
              </>
            )}
          </TextWrapper>
        </Content>
      </StyledWrapper>
    </ModalWrapper>
  );
};

LeaveReviewModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isSuccess: PropTypes.bool,
  submitError: PropTypes.string,
};

export default LeaveReviewModal;
